import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { TableCell } from './default-sort-schedule-setting.model';

export const OFFSET_OPTIONS: IOption[] = Array.from({ length: 11 }, (_, i) => ({
  label: `${i - 5}`,
  value: i - 5,
}));

export const HEADER_VALUES = [
  $localize`Sort`,
  $localize`Sunday`,
  $localize`Monday`,
  $localize`Tuesday`,
  $localize`Wednesday`,
  $localize`Thursday`,
  $localize`Friday`,
  $localize`Saturday`,
];

export const ROW_VALUES: TableCell[][] = [
  [
    {
      label: $localize`Sunrise`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Sunrise${day}Start`,
      formControlEnd: `Sunrise${day}End`,
      formControlOffset: `Sunrise${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Morning`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Morning${day}Start`,
      formControlEnd: `Morning${day}End`,
      formControlOffset: `Morning${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Day`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Day${day}Start`,
      formControlEnd: `Day${day}End`,
      formControlOffset: `Day${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Twilight`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Twilight${day}Start`,
      formControlEnd: `Twilight${day}End`,
      formControlOffset: `Twilight${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Night`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Night${day}Start`,
      formControlEnd: `Night${day}End`,
      formControlOffset: `Night${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Preload`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Preload${day}Start`,
      formControlEnd: `Preload${day}End`,
      formControlOffset: `Preload${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Local`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Local${day}Start`,
      formControlEnd: `Local${day}End`,
      formControlOffset: `Local${day}Offset`,
    })),
  ],
  [
    {
      label: $localize`Afternoon`,
      formControl: null,
      formControlStart: null,
      formControlEnd: null,
      formControlOffset: null,
    },
    ...['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'].map((day) => ({
      label: null,
      formControl: null,
      formControlStart: `Afternoon${day}Start`,
      formControlEnd: `Afternoon${day}End`,
      formControlOffset: `Afternoon${day}Offset`,
    })),
  ],
];

export const CVIS_OPTIONS: IOption[] = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
];
